export class cShop {
  filterButton   = document.querySelector('.c-shop-header > button') as HTMLButtonElement;
  filterDetails  = document.querySelector('.c-shop-header > div')    as HTMLElement;
  addToCartLinks = document.querySelectorAll('li.product a.add_to_cart_button') as unknown as HTMLAnchorElement[];

  constructor() {

    this.filterButton.addEventListener('click', () =>{
      this.filterDetails.classList.toggle('c-hidden');
    });

    for(const a of this.addToCartLinks) {
      const link = a.dataset.cl;
      if (link === undefined) continue;
      a.href = link;
    }

    const buttons = document.querySelectorAll('li.product .add_to_cart_button');
    for(const button of buttons) {
      if (!(button instanceof HTMLAnchorElement)) continue;

      button.addEventListener('click', () =>{

        const gaData = {
          currency : 'CHF', 
          value    : Number(button.dataset.price ?? '0'),
          items    : [{
            item_id   : button.dataset.product_sku ?? 'unknown',
            item_name : button.dataset.name        ?? 'unknown',
            price     : Number(button.dataset.price ?? '0'),
            quantity  : 1,
            currency  : 'CHF'
          }]
        }
        window.gtag('event','add_to_cart', gaData);
      });
    }
  }
}